import React from 'react';
import { SvgIcon } from '../svg-icon';

export const Share = props => (
  <SvgIcon {...props} viewBox="0 0 18 15">
    <path d="M11 4V0L18 7L11 14V9.9C6 9.9 2.5 11.5 0 15C1 10 4 5 11 4Z" />
  </SvgIcon>
);
